// Returns a function that prefixes an internal path with the active locale, so
// links on a Spanish page keep the visitor in Spanish (/pricing → /es/pricing).
// English (the default locale) stays prefix-free.
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LNGS, DEFAULT_LNG } from './index';

export default function useLocalePath() {
  const { i18n } = useTranslation();
  const lng = SUPPORTED_LNGS.includes(i18n.language) ? i18n.language : DEFAULT_LNG;
  return (path) => {
    if (lng === DEFAULT_LNG) return path;
    if (path === '/') return `/${lng}`;
    return `/${lng}${path}`;
  };
}
